module.exports = __webpack_public_path__ + "static/media/sort.36ef50c8.svg";